'use client'

import { useEffect } from 'react'

import { useQueryParams } from '@hooks/useQueryParams'
import {
  UtmSearchQueryParams,
  updateUTMCookies,
} from '@navigation/utm-params-constants'

export const UtmParams = () => {
  const queryParams = useQueryParams<UtmSearchQueryParams>()

  useEffect(() => {
    const utm = updateUTMCookies(queryParams)

    if (!utm) return

    window.analytics?.identify({
      utm,
    })
  }, [queryParams])

  return null
}
